import { Spin as AntSpin } from 'antd'
import styled from 'styled-components'

import type { T_SpinProps } from './spin'

export const SC_Spin = styled(
  (props: T_SpinProps) => <AntSpin {...props} />
)`
  display: flex;
  height: 100%;
  justify-content: center;
`
